module.exports = __webpack_public_path__ + "img/lens-174-minus-11.c9f7a868.png";